var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 1C7.729 1 1 7.729 1 16s6.729 15 15 15 15-6.729 15-15S24.271 1 16 1zm0 28C8.832 29 3 23.168 3 16c0-3.225 1.187-6.173 3.139-8.447l3.732 3.732-2.828 9.428a1 1 0 0 0 1.906.603L9.721 19h2.635l.686 2.287a1 1 0 1 0 1.917-.574l-1.86-6.201 3.902 3.902V21a1 1 0 0 0 1 1h2c.182 0 .355-.035.532-.054l3.915 3.915A12.935 12.935 0 0 1 16.001 29zm-4.244-12h-1.512L11 14.48zm9.418 2.76L19 17.586V12h1c1.654 0 3 1.346 3 3v2a3.004 3.004 0 0 1-1.826 2.76zm4.687 4.687-3.22-3.22c1.411-.885 2.358-2.443 2.358-4.227v-2c0-2.757-2.243-5-5-5h-2a1 1 0 0 0-1 1v4.586L7.553 6.139A12.935 12.935 0 0 1 16 3c7.168 0 13 5.832 13 13 0 3.225-1.187 6.173-3.139 8.447z",
    fill: "#b90005",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockAd);
export default __webpack_public_path__ + "static/media/block-ad.1fb98c6e45207929c72dfa4c55f569e6.svg";
export { ForwardRef as ReactComponent };